import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { InputBaseType } from '@rd/form-builder/types';
import { PhysicalGiftCardFieldsMaxLength } from '@rd/types';
import {
  NUMBER_ONLY_REGEX,
  ONLY_US_ASCII_CHARACTERS,
  SPACE_ONLY_REGEX,
} from '@rd/utils/regex.utils';

@Injectable()
export class PhysicalAddressFormService {
  physicalAddressFormFields: InputBaseType[] = [
    {
      className: 'recipient-address-line1',
      key: 'addressLine1',
      labelTranslation: {
        label: 'gift_card.checkout.label.recipient_address_line1',
        emptyErrorLabel:
          'gift_card.checkout.error.recipient_address_line1_empty',
        invalidPatternErrorLabel:
          'gift_card.checkout.error.recipient_address_line1_invalid_pattern',
      },
      maxLength: PhysicalGiftCardFieldsMaxLength.ADDRESS_LINE_1,
      placeholder:
        'gift_card.checkout.label.recipient_address_line1_placeholder',
      requiredOnSubmit: true,
      syncValidators: [
        Validators.pattern(ONLY_US_ASCII_CHARACTERS),
        Validators.pattern(SPACE_ONLY_REGEX),
      ],
    },
    {
      className: 'recipient-address-line2',
      key: 'addressLine2',
      labelTranslation: {
        label: 'gift_card.checkout.label.recipient_address_line2',
        invalidPatternErrorLabel:
          'gift_card.checkout.error.recipient_address_line2_invalid_pattern',
      },
      maxLength: PhysicalGiftCardFieldsMaxLength.ADDRESS_LINE_2,
      syncValidators: [
        Validators.pattern(ONLY_US_ASCII_CHARACTERS),
        Validators.pattern(SPACE_ONLY_REGEX),
      ],
    },
    {
      className: 'recipient-city',
      key: 'city',
      labelTranslation: {
        label: 'gift_card.checkout.label.recipient_city',
        emptyErrorLabel: 'gift_card.checkout.error.recipient_city_empty',
        invalidPatternErrorLabel:
          'gift_card.checkout.error.recipient_city_invalid_pattern',
      },
      maxLength: PhysicalGiftCardFieldsMaxLength.CITY,
      requiredOnSubmit: true,
      syncValidators: [
        Validators.pattern(ONLY_US_ASCII_CHARACTERS),
        Validators.pattern(SPACE_ONLY_REGEX),
      ],
    },
    {
      key: 'state',
      labelTranslation: {
        label: 'gift_card.checkout.label.recipient_state',
        emptyErrorLabel: 'gift_card.checkout.error.recipient_state_empty',
        invalidPatternErrorLabel: '',
      },
      requiredOnSubmit: true,
      selectOptions: [
        { label: 'ACT', value: 'ACT' },
        { label: 'NSW', value: 'NSW' },
        { label: 'NT', value: 'NT' },
        { label: 'QLD', value: 'QLD' },
        { label: 'SA', value: 'SA' },
        { label: 'TAS', value: 'TAS' },
        { label: 'VIC', value: 'VIC' },
        { label: 'WA', value: 'WA' },
      ],
      type: 'select',
    },
    {
      className: 'recipient-postal-code',
      key: 'postalCode',
      labelTranslation: {
        label: 'gift_card.checkout.label.recipient_postal_code',
        emptyErrorLabel: 'gift_card.checkout.error.recipient_postal_code_empty',
        invalidPatternErrorLabel:
          'gift_card.checkout.error.recipient_postal_code_invalid_pattern',
      },
      maxLength: PhysicalGiftCardFieldsMaxLength.POSTAL_CODE,
      requiredOnSubmit: true,
      syncValidators: [
        Validators.pattern(NUMBER_ONLY_REGEX),
        Validators.pattern(SPACE_ONLY_REGEX),
      ],
    },
  ];
}
